import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import FilterableGallery from '../components/FilterableGallery'
import DealBox from '../components/DealBox'
import Image01 from '../images/atmospheric/image01.jpg'
import ReadMore from '../components/ReadMore';
import { FaWhatsapp } from "react-icons/fa6";

const BrandingPage = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash === '#branding-packages') {
            setTimeout(() => {
                const element = document.getElementById('branding-packages');
                if (element) {
                    const y = element.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }, 300);
        }
    }, [location]);

    return (
        <div>


            <div className="relative px-4 pt-56 md:pt-64 pb-20 flex flex-col items-center justify-center dotBg" dir="rtl">
                <div className="absolute inset-0 bg-black/55 backdrop-blur-[2px] pointer-events-none"></div>

                <div className="relative z-10 text-center gold-text max-w-[900px] px-4">
                    <h1 className="font-bold  text-3xl md:text-5xl">
                        עיצוב גרפי מיתוג ופרסום
                    </h1>
                    <h2 className="font-medium my-2 text-xl md:text-3xl text-mainColor ">
                        המרכיבים החשובים ביותר בנראות העסק שלכם
                    </h2>
                </div>

                <div className="relative z-10" data-aos="fade-down"
                    data-aos-easing="ease-in-out"
                    data-aos-delay="400"
                >

                    <button

                        className='m-4 button my-4  sm:m-8 bg-gradient-to-tr btnGradient text-mainColor  font-bold  sm:text-2xl text-xl rounded-full duration-300'
                        onClick={() => {
                            const phoneNumber = '972522849593';
                            const message = encodeURIComponent('היי, הגעתי מהאתר. אשמח לפרטים בנוגע לפרסום ועיצוב לעסק שלי');
                            const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
                            window.open(whatsappUrl, '_blank');
                        }}

                    >
                        <span className="button-content justify-around items-center flex">
                            <span className="pl-2">למעבר לווצאפ</span> <FaWhatsapp size={35} />
                        </span>
                    </button>

                </div>
            </div>

            <div dir='rtl' className='py-20 p-4 brandingBg'>
                <h2 data-aos="fade-down"
                    data-aos-easing="ease-in-out" className=" font-bold px-4 mt-8 text-lg md:text-xl my-4 mx-auto text-center gold-text ">
                    הכול מתחיל במיתוג
                </h2>
                <h3 data-aos="fade-in"
                    data-aos-easing="ease-in-out" className='text-mainColor max-w-[700px] mx-auto text-center text-base md:text-xl'>
                    אנחנו מאמינים   שמיתוג נכון ומדויק הוא הבסיס להכול. אנחנו מתחילים בלהבין מה הם הערכים של העסק, מה השירותים שהוא מציע ומה מייחד אותו. ולאחר מכן  בונים מיתוג בעיצוב אישי שמתאים לעסק
                </h3>
                <h3 data-aos="fade-in"
                    data-aos-easing="ease-in-out" className='text-mainColor max-w-[700px] mx-auto text-center text-base md:text-xl'>
                    ניתן לבצע אצלנו גם הדפסות במידת הצורך ומשלוח עד בית העסק
                </h3>
            </div>

            <FilterableGallery />

            <div id='branding-packages' className='py-20 p-4 specialBg'>
                <div className="text-center text-mainColor mx-auto max-w-[900px] px-4">
                    <h1 data-aos="fade-down"
                        data-aos-easing="ease-in-out" className="font-bold gold-text  text-3xl md:text-5xl">
                        חבילות מיתוג
                    </h1>
                    <h2 data-aos="fade-in"
                        data-aos-easing="ease-in-out" className="font-medium my-2 text-xl md:text-3xl text-mainColor ">
                        חבילות המיתוג של דיגיטל פלוס                    </h2>
                </div>
                <div className=" max-w-[1200px] items-center mt-16 p-4 mx-auto ">

                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 rounded-2xl gap-y-20 gap-x-8 mx-8 ">
                        {/* Card components */}
                        <div data-aos="fade-down"
                            data-aos-easing="ease-in-out">


                            <DealBox
                                header="חבילת בסיס"
                                textArr={[
                                    "עיצוב לוגו",
                                    "עיצוב כרטיס ביקור",
                                    "כל הקבצים המתאימים"
                                ]}
                                whatsappText="היי הגעתי מהאתר, אשמח לפרטים בנוגע לחבילת מיתוג בסיס לעסק שלי"
                                price='650 ש"ח'

                            />
                        </div>

                        <div data-aos="fade-down"
                            data-aos-easing="ease-in-out">
                            <DealBox
                                header="חבילת פרו"
                                textArr={[
                                    "עיצוב לוגו",
                                    "עיצוב כרטיס ביקור",
                                    "עיצוב מודעת פרסום לרשתות",
                                    "כל הקבצים המתאימים"
                                ]}
                                whatsappText="היי הגעתי מהאתר, אשמח לפרטים בנוגע לחבילת מיתוג פרו לעסק שלי"
                                price='950 ש"ח'

                            />
                        </div>
                        <div data-aos="fade-down"
                            data-aos-easing="ease-in-out">
                            <DealBox
                                header="חבילת פרימיום"
                                textArr={[
                                    "עיצוב לוגו",
                                    "עיצוב כרטיס ביקור",
                                    "עיצוב 2 מודעות פרסום לרשתות החברתיות",
                                    "עיצוב ניירת: נייר מכתבים ומעטפות",
                                    "כל הקבצים המתאימים"
                                ]}
                                whatsappText="היי הגעתי מהאתר, אשמח לפרטים בנוגע לחבילת מיתוג פרימיום לעסק שלי"
                                price='1500 ש"ח'
                            />
                        </div>
                    </div>

                    <p dir='rtl' className='max-w-[400px] mx-auto text-center text-white mt-12'>* המחירים לפני מע״מ</p>
                    <p dir='rtl' className='max-w-[400px] mx-auto text-center text-white mt-4'>* ניתן גם להדפיס את המוצרים בעלות נפרדת</p>

                </div>
            </div>



            <div className='p-4 py-20 pb-10  specialBg '>
                <h2 data-aos="fade-in"
                    data-aos-easing="ease-in-out" className=" font-bold px-4 mt-8 text-lg md:text-xl my-4 mx-auto text-center text-mainColor ">
                    עיצוב גרפי ויצירת תוכן פרסומי                </h2>
                <h1 data-aos="fade-down"
                    data-aos-easing="ease-in-out" dir='rtl' className="font-bold max-w-[800px] mx-auto  text-3xl md:text-5xl text-center gold-text " >

                    למותג יש אישיות, חלק בלתי נפרד מהאישיות הוא הויזואליות.
                </h1>
                <div className='flex flex-col lg:flex-row-reverse mx-auto  max-w-[768px]  lg:max-w-[1200px] p-4 md:p-8 my-8 specialBgrounded-2xl' >

                    <div className='rounded-2xl lg:mx-4 max-w-[768px] lg:max-w-[500px] border-2 border-bgPath duration-300 overflow-hidden'>
                        <img src={Image01} className='object-cover w-full h-auto min-h-full hover:scale-105 duration-300' alt="" />
                    </div>
                    <div className='max-w-[768px] my-4 '>


                        <h2 dir='rtl' className=" font-light px-4 my-2 text-lg md:text-xl max-w-[1000px] mx-auto text-right text-mainColor ">
                            בעולם שכל כך מלא בפרסומות, מהרחוב ועד למסך הפלאפון, אנחנו יודעים כמה זה חשוב שהמותג שלכם יתבלט. אנחנו פה בדיוק בשביל זה - לעזור לכם להפוך את המותג שלכם לזה שאנשים לא רק שמים לב אליו, אלא גם זוכרים אותו.

                            כאלה שטבלו בעולם העיצוב והתוכן שנים, אנחנו מבינים שכל פרויקט, קטן או גדול, הוא סיפור לגופו.  אנחנו פה לדאוג שהעיצוב שלכם ידבר בשפה שהלקוחות שלכם לא רק שומעים, אלא גם מרגישים.                        </h2>



                    </div>

                </div>


                {/* <h2 dir='rtl' className=" font-bold px-4 mt-8 text-lg md:text-xl max-w-[1000px] mx-auto text-center text-shineColor2 ">
    השירותים שלי            </h2> */}




            </div>



            <ReadMore links={[
                { text: 'דף הבית', link: '/' },
                { text: 'דפוס דיגיטלי', link: '/Print' },
                { text: 'סרטוני בינה מלאכותית לעסקים', link: '/AIVideo' },
                { text: 'עריכת וידאו', link: '/VideoEditing' },
                { text: 'חבילות מיתוג', link: '/Branding#branding-packages' },
                { text: 'יצירת קשר', link: '/Contact' },
            ]} />


        </div >
    )
}

export default BrandingPage